// "Add user to this booking" modal of the Passengers section: a customer and N seats.
import type { FormInstance } from 'antd';
import { Form, InputNumber, Modal, Typography } from 'antd';

import { UserSelect } from '../../components/UserSelect';

const { Text } = Typography;

export function AddUserModal({
  addUserForm,
  addUserOpen,
  setAddUserOpen,
  onOk,
  addUserValid,
  addUserMut,
  refreshingSeats,
  seatsLeft,
  seatsError,
}: {
  addUserForm: FormInstance<{ userId: string; seats: number }>;
  addUserOpen: boolean;
  setAddUserOpen: (open: boolean) => void;
  onOk: () => void;
  addUserValid: boolean;
  addUserMut: { isPending: boolean };
  refreshingSeats: boolean;
  seatsLeft: number;
  seatsError: (v: unknown) => string | null;
}) {
  return (
    <Modal
      title="Add user to this booking"
      open={addUserOpen}
      onCancel={() => setAddUserOpen(false)}
      onOk={onOk}
      okText="Add user"
      okButtonProps={{ disabled: !addUserValid }}
      confirmLoading={addUserMut.isPending}
      destroyOnClose
    >
      <Form form={addUserForm} layout="vertical" initialValues={{ seats: 1 }}>
        <Form.Item name="userId" label="Customer" rules={[{ required: true, message: 'Choose a customer' }]}>
          <UserSelect />
        </Form.Item>
        <Form.Item
          name="seats"
          label={refreshingSeats ? 'Seats (checking free seats…)' : `Seats (${seatsLeft} free)`}
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              validator: (_r, v) => {
                const err = seatsError(v);
                return err ? Promise.reject(new Error(err)) : Promise.resolve();
              },
            },
          ]}
        >
          {/* No min/max/precision: out-of-range or fractional values are
              shown as errors, not silently corrected. */}
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
        <Text type="secondary">
          The seats are held for this customer but are unpaid: they do not count towards MGAV until the
          customer pays in the app. The customer is told by push notification and email.
        </Text>
      </Form>
    </Modal>
  );
}
